(function () {
  const SELECTOR = '.product__block--description';
  const LABEL_MORE = 'Leggi tutto';
  const LABEL_LESS = 'Leggi meno';

  const ICON =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function build(block) {
    if (block.classList.contains('pdc-ready')) return;
    if (!block.textContent.trim()) return;

    /* Numero righe: default 4 mobile / 6 desktop via CSS.
       data-pdc-lines forza un valore unico su tutti i breakpoint. */
    if (block.dataset.pdcLines) {
      block.style.setProperty('--pdc-lines', block.dataset.pdcLines);
    }

    const content = document.createElement('div');
    content.className = 'product__description-content';
    while (block.firstChild) content.appendChild(block.firstChild);
    block.appendChild(content);

    const labelMore = block.dataset.pdcLabelMore || LABEL_MORE;
    const labelLess = block.dataset.pdcLabelLess || LABEL_LESS;

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'product__description-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.hidden = true;
    toggle.innerHTML =
      '<span class="product__description-toggle-label">' +
      labelMore +
      '</span><span class="product__description-toggle-icon">' +
      ICON +
      '</span>';
    block.appendChild(toggle);

    const label = toggle.querySelector('.product__description-toggle-label');

    function checkOverflow() {
      if (block.classList.contains('is-expanded')) return;
      toggle.hidden = content.scrollHeight <= content.clientHeight + 1;
    }

    toggle.addEventListener('click', function () {
      const expanded = block.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      label.textContent = expanded ? labelLess : labelMore;
      if (!expanded) {
        block.scrollIntoView({ block: 'nearest' });
        checkOverflow();
      }
    });

    block.classList.add('pdc-ready');
    checkOverflow();

    if ('ResizeObserver' in window) {
      new ResizeObserver(checkOverflow).observe(content);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(checkOverflow);
    }
  }

  function init(root) {
    (root || document).querySelectorAll(SELECTOR + ':not(.pdc-ready)').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', function () {
    init();
  });
})();
